// extracted by mini-css-extract-plugin
export var noBottomPadding = "pageSection-module--noBottomPadding--06776";
export var wrapper = "pageSection-module--wrapper--c1860";